import { visit } from "unist-util-visit"
import type { Node } from "unist"

/**
 * remark plugin: turn container directives `:::tip`, `:::note`, `:::warning`
 * and `:::danger` into `<div>` nodes carrying `data-callout` (and optional
 * `data-title`) so the markdown renderer can swap in a styled callout. Other
 * directives are left untouched.
 */

const CALLOUT_NAMES = new Set(["tip", "note", "warning", "danger"])

interface DirectiveNode {
  type: string
  name?: string
  attributes?: Record<string, string | null | undefined>
  data?: {
    hName?: string
    hProperties?: Record<string, unknown>
  }
}

export const remarkCallouts = () => {
  return (tree: Node): void => {
    visit(tree, (node) => {
      const directive = node as unknown as DirectiveNode
      if (
        directive.type === "containerDirective" &&
        directive.name &&
        CALLOUT_NAMES.has(directive.name)
      ) {
        const data = (directive.data ??= {})
        data.hName = "div"
        data.hProperties = {
          className: ["docs-callout-source"],
          "data-callout": directive.name,
          "data-title": directive.attributes?.title ?? undefined,
        }
      }
    })
  }
}

export default remarkCallouts
